import { CommonModule }         from '@angular/common';
import { NgModule }             from '@angular/core';
import { DownloadButtonModule } from '@shared/components/download-button/download-button.module';
import { ResultViewComponent }  from './result-view.component';


@NgModule( {
	declarations: [
		ResultViewComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Shared
		DownloadButtonModule
	],
	exports: [
		ResultViewComponent
	]
} )
export class ResultViewModule {}
